import { withStep } from '../step/withStep';
import { withPlayer } from '../step/player/withPlayer';
import { stepModel } from '../step/step-model';
import { stepSequencingModel } from './step-sequencing-model';

export var withSequencingStep = function withSequencingStep() {
  for (var _len = arguments.length, connectors = Array(_len), _key = 0; _key < _len; _key++) {
    connectors[_key] = arguments[_key];
  }

  return withStep(withPlayer(function (props) {
    return {
      submitStep: function submitStep() {
        var step = props.step,
            player = props.player;

        var answers = stepSequencingModel.getAnswers(step, player.values);
        var correct = stepModel.areAnswersCorrect(step, answers);
        player.submitStep({ progressStepType: props.progressStepType, answers: answers, correct: correct });
      }
    };
  }), [].concat(connectors));
};